// test2125
(2125 && 0);
